import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import { Ctrl, CtrlCollection, CtrlStates, CtrlType } from '@yuigoto/ctrl';
import { TextEditor } from 'components/general/TextEditor';
/**
 * Components/Renderers/ControlRenderer
 * ----------------------------------------------------------------------
 */
export class ControlRenderer extends Component {
  state = {
    doShowSelect: false,
  };
  /**
   *
   */
  render() {
    const { props } = this;
    const { control } = props;
    if (CtrlType.HIDDEN === control.type) return null;
    let _cls = ['form-group'];

    return (
      <div className={classnames(_cls, props.className, control.wrapClass)}>
        {this._renderMainLabel(control)}
        {this._renderDescription(control)}
        {(() => {
          if (!control.hasOwnProperty('component')) return null;

          const { component: Comp } = control;

          if (Comp !== null) {
            return <Comp />;
          }
          return null;
        })()}
        {this._renderInput(control)}
        {control.message !== '' &&
          control.type !== CtrlType.SINGLE_OPTION &&
          control.type !== CtrlType.RADIO_GROUP &&
          control.type !== CtrlType.MULTIPLE_OPTION &&
          control.type !== CtrlType.CHECKBOX_GROUP &&
          this._renderFeedback(control)}
      </div>
    );
  }
  // --------------------------------------------------------------------
  static renderCollection(collection) {
    if (collection instanceof CtrlCollection) {
      let rendered = [];
      for (let i = 0; i < collection.collection.length; i++) {
        if (collection.collection[i] instanceof CtrlCollection) {
          rendered.push(
            <div className={'form-row'} key={i}>
              {ControlRenderer.renderCollection(collection.collection[i])}
            </div>
          );
        } else {
          rendered.push(
            <ControlRenderer key={i} control={collection.collection[i]} />
          );
        }
      }
      return rendered;
    }
    return null;
  }
  // --------------------------------------------------------------------
  /**
   *
   * @param {Ctrl} control
   */
  _renderMainLabel(control) {
    if (control.type !== CtrlType.BOOLEAN) {
      let info = control.info ? <small>{control.info}</small> : null,
        required = control.required ? '*' : null;
      return (
        <label>
          {control.label}
          {required} {info}
        </label>
      );
    }
    return null;
  }
  /**
   *
   * @param {Ctrl} control
   */
  _renderInput(control) {
    switch (control.type) {
      case CtrlType.MULTIPLE_OPTION:
      case CtrlType.CHECKBOX_GROUP:
        return this._inputCheckboxGroup(control);
      case CtrlType.SINGLE_OPTION:
      case CtrlType.RADIO_GROUP:
        return this._inputRadioGroup(control);
      case CtrlType.TEXTAREA:
        if (control.custom) {
          return this._inputRichText(control);
        }
        return this._inputTextArea(control);
      case CtrlType.DROPDOWN:
        return this._inputDropdown(control);
      case CtrlType.DATALIST:
        return this._inputDatalist(control);
      case CtrlType.BOOLEAN:
        return this._inputBoolean(control);
      default:
        return this._inputDefault(control);
    }
  }
  /**
   *
   * @param {Ctrl} control
   */
  _renderDescription(control) {
    if (control.type !== CtrlType.BOOLEAN) {
      if (control.description) {
        return <p className={'form-info'}>{control.description}</p>;
      }
    }
    return null;
  }
  /**
   *
   * @param {Ctrl} control
   */
  _renderFeedback(control) {
    let _cls = ['form-feedback'];
    if (control.state === CtrlStates.ERROR) _cls.push('invalid-feedback');
    if (control.state === CtrlStates.VALID) _cls.push('valid-feedback');
    return <div className={classnames(_cls)}>{control.message}</div>;
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputDefault(control) {
    let _cls = ['form-control'];
    if (control.state === CtrlStates.ERROR) _cls.push('is-invalid');
    if (control.state === CtrlStates.VALID) _cls.push('is-valid');
    let inputObject = {
      className: classnames(_cls, control.customClass),
      value: control.value || control.value === 0 ? control.value : '',
      type: control.getType(),
      placeholder: control.placeholder,
      state: control.state,
      onChange: e =>
        control.onValueChange(e.target.value) || this.forceUpdate(),
      disabled: control.disabled,
    };
    if (control.autocomplete) {
      inputObject.autoComplete = control.autocomplete;
    }
    return <input {...inputObject} />;
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputRichText(control) {
    let _cls = ['form-control'];
    if (control.state === CtrlStates.ERROR) _cls.push('is-invalid');
    if (control.state === CtrlStates.VALID) _cls.push('is-valid');
    let inputObject = {
      className: classnames(_cls, control.customClass),
      value: control.value || control.value === 0 ? control.value : '',
      type: control.getType(),
      placeholder: control.placeholder,
      state: control.state,
      onChange: value => control.onValueChange(value) || this.forceUpdate(),
      disabled: control.disabled,
    };
    return <TextEditor {...inputObject} />;
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputBoolean(control) {
    let { value } = control;
    let _id = control.name + '-' + new Date().toString(),
      _checked = value === true,
      _clsInput,
      _clsCheck,
      _clsLabel;
    if (control.custom) {
      _clsInput = ['custom-control', 'custom-checkbox'];
      _clsCheck = ['custom-control-input'];
      _clsLabel = ['custom-control-label'];
    } else {
      _clsInput = ['form-check'];
      _clsCheck = ['form-check-input'];
      _clsLabel = ['form-check-label'];
    }
    if (control.state === CtrlStates.ERROR) _clsCheck.push('is-invalid');
    if (control.state === CtrlStates.VALID) _clsCheck.push('is-valid');

    if (control.custom) {
      return (
        <div className={classnames(_clsInput, control.customClass)}>
          <input
            id={_id}
            type={control.getType()}
            name={control.name}
            checked={_checked}
            onChange={e => control.onBooleanChange(value) || this.forceUpdate()}
            aria-invalid={control.state === CtrlStates.ERROR}
            disabled={control.disabled}
          />

          {/* <label htmlFor={_id} className={classnames(_clsLabel)}>
            {control.label}
          </label> */}

          <label htmlFor={_id} className={classnames(_clsLabel)}>
            {control.description}
          </label>
        </div>
      );
    }
    return (
      <div className={classnames(_clsInput, control.customClass)}>
        <input
          id={_id}
          className={classnames(_clsCheck)}
          type={control.getType()}
          name={control.name}
          checked={_checked}
          onChange={e => control.onBooleanChange(value) || this.forceUpdate()}
          aria-invalid={control.state === CtrlStates.ERROR}
          disabled={control.disabled}
        />
        <label htmlFor={_id} className={classnames(_clsLabel)}>
          {control.label}
        </label>
      </div>
    );
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputCheckboxGroup(control) {
    let { options, value } = control;
    let optionGroup = options.map((item, key) => {
      let _id = `${control.name}-checkbox-${key}`,
        _checked,
        _click,
        _clsInput,
        _clsCheck,
        _clsLabel;
      if (item.custom === true) {
        _clsLabel = ['custom-control-label'];
        _clsCheck = ['custom-control-input'];
        _clsInput = ['custom-control custom-checkbox'];
      } else {
        _clsLabel = ['form-check-label'];
        _clsCheck = ['form-check-input'];
        _clsInput = ['form-check'];
        if (item.inline === true) _clsInput.push('form-check-inline');
      }
      if (control.state === CtrlStates.ERROR) _clsCheck.push('is-invalid');
      if (control.state === CtrlStates.VALID) _clsCheck.push('is-valid');
      _checked =
        Array.isArray(value) &&
        (value.includes(item.value) || value.includes(item.name));
      _click = () => {
        control.onValueToggle(item.value || item.name) || this.forceUpdate();
      };

      if (item.custom) {
        return (
          <div key={key} className={classnames(_clsInput, control.customClass)}>
            <input
              id={_id}
              type={control.getType()}
              name={control.name}
              checked={_checked}
              onChange={_click}
              aria-invalid={control.state === CtrlStates.ERROR}
              disabled={item.disabled}
            />
            <label htmlFor={_id} className={classnames(_clsLabel)}>
              {item.name}
            </label>
          </div>
        );
      }
      return (
        <div key={key} className={classnames(_clsInput, control.customClass)}>
          <input
            id={_id}
            className={classnames(_clsCheck)}
            type={control.getType()}
            name={control.name}
            checked={_checked}
            onChange={_click}
            aria-invalid={control.state === CtrlStates.ERROR}
            disabled={item.disabled}
          />
          <label htmlFor={_id} className={classnames(_clsLabel)}>
            {item.name}
          </label>
        </div>
      );
    });
    return options && optionGroup;
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputRadioGroup(control) {
    let { options, value } = control;
    let optionGroup = options.map((item, key) => {
      let _id = `${control.name}-radio-${key}`,
        _checked,
        _click,
        _clsInput,
        _clsCheck,
        _clsLabel;
      if (item.custom === true) {
        _clsLabel = ['custom-control-label'];
        _clsCheck = ['custom-control-input'];
        _clsInput = ['custom-control custom-radio'];
      } else {
        _clsLabel = ['form-check-label'];
        _clsCheck = ['form-check-input'];
        _clsInput = ['form-check'];
        if (item.inline === true) _clsInput.push('form-check-inline');
      }
      if (control.state === CtrlStates.ERROR) _clsCheck.push('is-invalid');
      if (control.state === CtrlStates.VALID) _clsCheck.push('is-valid');
      _checked = value === item.value;
      _click = () => {
        control.onValueChange(item.value || item.name) || this.forceUpdate();
      };

      if (item.custom) {
        return (
          <div key={key} className={classnames(_clsInput, control.customClass)}>
            <input
              id={_id}
              type={control.getType()}
              name={control.name}
              checked={_checked}
              onChange={_click}
              aria-invalid={control.state === CtrlStates.ERROR}
              disabled={item.disabled}
            />
            <label htmlFor={_id} className={classnames(_clsLabel)}>
              {item.name}
            </label>
          </div>
        );
      }
      return (
        <div key={key} className={classnames(_clsInput, control.customClass)}>
          <input
            id={_id}
            className={classnames(_clsCheck)}
            type={control.getType()}
            name={control.name}
            checked={_checked}
            onChange={_click}
            aria-invalid={control.state === CtrlStates.ERROR}
            disabled={item.disabled}
          />
          <label htmlFor={_id} className={classnames(_clsLabel)}>
            {item.name}
          </label>
        </div>
      );
    });
    return options && optionGroup;
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputDatalist(control) {
    let _cls = ['form-control'];
    if (control.state === CtrlStates.ERROR) _cls.push('is-invalid');
    if (control.state === CtrlStates.VALID) _cls.push('is-valid');
    let selectOptions = [],
      defaultValue = null;
    if (control.options && control.options.length > 0) {
      for (let opt of control.options) {
        if (control.value === opt.value) {
          defaultValue = {
            value: opt.value,
            label: opt.name,
          };
        }
        selectOptions.push({
          value: opt.value,
          label: opt.name,
        });
      }
    }
    const customStyles = {
      option: (provided, _) => ({
        ...provided,
        color: '#babdb6',
        backgroundColor: 'transparent',
        cursor: 'default',
        ':hover': {
          backgroundColor: '#1e90ff',
          border: '2px solid #000',
          color: '#fff',
        },
      }),
      control: () => ({
        border: '1px solid #babdb6',
        borderRadius: '2px',
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 2,
        padding: '0 .5rem',
        transition: '.15s',
        outline: '0 solid transparent',
        letterSpacing: '0.25px',
        height: '2em',
        cursor: 'text',
      }),
      placeholder: () => ({
        display: 'none',
      }),
      valueContainer: () => ({
        padding: 0,
        input: {
          height: '2em',
        },
      }),
      singleValue: () => ({
        color: '#878d80',
        overflow: 'hidden',
        height: '2em',
      }),
      input: () => ({
        margin: 0,
        padding: 0,
        height: '2em',
        position: 'absolute',
        top: '0%',
      }),
      indicatorsContainer: () => ({
        position: 'absolute',
        top: '0%',
        right: '0%',
        cursor: 'default',
        svg: {
          color: '#9da297',
        },
      }),
    };
    return (
      <>
        <Select
          options={selectOptions}
          styles={customStyles}
          value={defaultValue}
          onChange={value => {
            return control.onValueChange(value.value) || this.forceUpdate();
          }}
        />
      </>
    );
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputDropdown(control) {
    let _cls = ['form-control'];
    if (control.state === CtrlStates.ERROR) _cls.push('is-invalid');
    if (control.state === CtrlStates.VALID) _cls.push('is-valid');
    if (control.custom === true) _cls.push('custom-select');
    let _opt = control.options.map((option, key) => {
      return (
        <option value={option.value} key={key}>
          {option.name}
        </option>
      );
    });
    return (
      <select
        className={classnames(_cls, control.customClass)}
        onChange={e =>
          control.onValueChange(e.target.value) || this.forceUpdate()
        }
        value={control.value || control.value === 0 ? control.value : ''}
        disabled={control.disabled}
      >
        <option value={0} disabled selected={!control.value}>
          Selecione
        </option>
        {_opt}
      </select>
    );
  }
  /**
   *
   * @param {Ctrl} control
   */
  _inputTextArea(control) {
    let _cls = ['form-control'];
    if (control.state === CtrlStates.ERROR) _cls.push('is-invalid');
    if (control.state === CtrlStates.VALID) _cls.push('is-valid');
    return (
      <textarea
        className={classnames(_cls, control.customClass)}
        value={control.value || control.value === 0 ? control.value : ''}
        placeholder={control.placeholder}
        cols={control.cols || 30}
        rows={control.rows || 8}
        onChange={e =>
          control.onValueChange(e.target.value) || this.forceUpdate()
        }
      />
    );
  }
}
ControlRenderer.defaultProps = {
  control: null,
  className: '',
};
ControlRenderer.propTypes = {
  control: PropTypes.instanceOf(Ctrl).isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};
